/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2023-07-14 09:35:17
 * Description :
 * -----
 * Last Modified: 2023-08-01 15:09:20
 * Modified By :
 * -----
 * Copyright (c) 2022 Magina Corporation. All rights reserved.
 */

import { get, post } from 'src/api/http';
import * as type from './type';
import { ReturnTableData, ImportProgressData } from 'src/api/types';
class KeyMgnt {
    getDeviceKey (data:type.GetDeviceKeyParam):Promise<ReturnTableData<type.GetDeviceKeyRow>> {
        return get('/key-management/device-key', data);
    }
    getClientInfo (deviceType: type.DevcieType): Promise<type.ClientRow[]> {
        return get('/key-management/client-info', {deviceType});
    }
    syncKey (data: type.SyncKeyParam): Promise<boolean> {
        return post('/key-management/sync-key', data);
    }
    QueryAutoUpdatePolicy (data: type.QueryAutoUpdatePolicyParam): Promise<ReturnTableData<type.QueryAutoUpdatePolicyRows>> {
        return get('/auto-update-policy/list', data);
    }
    queryTaskList (data: type.QueryTaskParam): Promise<ReturnTableData<type.QueryTaskRow>> {
        return get('/key-management/device-task', data);
    }
    startJob (ids: string[]): Promise<boolean> {
        return post('/auto-update-policy/deployment', ids);
    }
    stopJob (ids: string[]): Promise<boolean> {
        return post('/auto-update-policy/pause', ids);
    }
    executeJob (ids: string[]): Promise<boolean> {
        return post('/auto-update-policy/execute', ids);
    }
    updateKeyType (data: type.UpdateKeyTypeParam): Promise<boolean> {
        return post('/key-management/update-key', data);
    }
    addPolicy (data: type.AddPolicyParam): Promise<boolean> {
        return post('/auto-update-policy/add', data);
    }
    getKeyType (): Promise<type.KeyTypeRow[]> {
        return get('/key-management/meter-key-type');
    }
    editorPolicy (data: type.UpdatePolicyParam): Promise<boolean> {
        return post('/auto-update-policy/edit', data);
    }
    deletePolicy (ids: string[]): Promise<boolean> {
        return post('/auto-update-policy/delete', ids);
    }
    resendTask (data: type.ResendTaskParam): Promise<boolean> {
        return post('/key-management/resend-task', data);
    }
    importUpdateKey (data: type.ImportUpdateKeyParam): Promise<any> {
        return post('/key-management/import-update-key', data);
    }
    getImportProgress (fileId: string): Promise<ImportProgressData> {
        return get('/key-management/execute-progress', {fileId});
    }
}

export default new KeyMgnt();
